import { render, staticRenderFns } from "./ProjectLog.vue?vue&type=template&id=dfaa3f64"
import script from "./ProjectLog.vue?vue&type=script&lang=js"
export * from "./ProjectLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports